
<template>
	<footer class="footer">
		<div class="content has-text-centered OrdersView__Copyrights">
			<p>
				&copy; {{ currentYear }}
				Route Planner |
        Opieka techniczna:
        <a href="https://trustdeal.pl">
          <img src="/img/trustdeal.svg" alt="Trust Deal" style="height: 13px" />
        </a>
			</p>
		</div>
	</footer>
</template>

<script>
import config from '@/config'

export default {
	name: 'Footer',
	data() {
		return {
			company: config.company
		}
	},
	computed: {
		currentYear() {
			return new Date().getFullYear()
		}
	}
}
</script>

<style lang="scss" scoped>
.footer {
	padding: 1rem 1.5rem;
	p {
		font-size: 14px;
		&:last-child {
			margin-bottom: 0.5rem;
		}
	}
}
</style>
